//需要定义数据
import { ExportExcel } from '@/handler/excel_handler'
// import { COU_ExportTxt } from '@/utils/co_util'
// var nameToItemMap = {}
// myConfig.map((item) => {
//   nameToItemMap[item.name] = item
// })
export function GetExportConfig(key, myConfigs) {
  var a = localStorage.getItem(key + '_GetExportChecked')
  var checkKeyMap = {}
  try {
    if (a) checkKeyMap = JSON.parse(a)
  } catch (error) {
    console.log(error)
  }
  console.log('获取本地的配置数据')
  console.log(checkKeyMap)
  var data = []
  var checkedData = []
  myConfigs.map((de) => {
    var checkOK = checkKeyMap[de.key]
    if (checkOK == '1') {
      de.isCheck = true
    } else if (checkOK == '0') {
      de.isCheck = false
    }
    data.push(de.name)
    if (de.isCheck) checkedData.push(de.name)
  })
  return { data, checkedData }
}

export function SaveExportConfig(myKey, myConfigs, checkedData) {
  if (!checkedData || checkedData.length == 0) return

  var nameToItemMap = {}
  var checkKeyMap = {}

  myConfigs.map((item) => {
    nameToItemMap[item.name] = item
    checkKeyMap[item.key + ''] = '0'
  })
  console.log(nameToItemMap)
  //获取nameTomap
  checkedData.map((name) => {
    var checkedItem = nameToItemMap[name]
    checkKeyMap[checkedItem.key + ''] = '1'
  })
  console.log('存储检查配置数据')
  console.log(checkKeyMap)
  console.log(checkedData)
  localStorage.setItem(myKey + '_GetExportChecked', JSON.stringify(checkKeyMap))
}

function getCheckedKeys(myConfigs, checkedData) {
  if (!checkedData || checkedData.length == 0) return

  var nameToItemMap = {}
  var checkKeyMap = {}

  myConfigs.map((item) => {
    nameToItemMap[item.name] = item
    checkKeyMap[item.key + ''] = '0'
  })
  var checkedItems = []
  console.log(nameToItemMap)
  //获取nameTomap
  checkedData.map((name) => {
    var checkedItem = nameToItemMap[name]
    checkedItems.push(checkedItem)
    checkKeyMap[checkedItem.key + ''] = '1'
  })
  return { checkKeyMap, checkedItems }
}

export function GetCopyContent(itemList, myConfigs, checkedData, isShowZero, isExportColumnTitle) {
  //获取ken
  var { checkKeyMap } = getCheckedKeys(myConfigs, checkedData)
  var content = ''
  // 【复制】和【导出文本】 可以选择是否显示表头
  if (isExportColumnTitle) {
    const exportField = Object.keys(checkKeyMap);
    for(let item of myConfigs) {
      if (exportField.includes(item.key)) {
        content += item.name + "\t";
      }
    }
  }
  itemList.map((item) => {
    var line = ''
    for (var key in checkKeyMap) {
      if (checkKeyMap[key] != "1") continue
      if (line != '') line += '\t'
      if (!item[key]) {
        item[key] = isShowZero ? 0 : ''
        // continue
      }
      line += item[key]
    }
    // for (var key in item) {
    //   if (checkKeyMap[key] != '1') continue
    //   if (line != '') line += '\t'
    //   line += item[key]
    // }
    if (!line) return
    if (content != '') content += '\n'
    content += line
  })
  return content
}

// export function ExportToTxt(itemList, myConfigs, checkedData, isShowZero, isExportColumnTitle) {
//   var data = GetCopyContent(itemList, myConfigs, checkedData, isShowZero, isExportColumnTitle)
//   var fileName = '导出txt.txt'
//   COU_ExportTxt(fileName, data)
// }
// //导出execel
export function ExportToExcel(itemList, myConfigs, checkedData, isShowZero) {
  var coms = []
  var { checkKeyMap, checkedItems } = getCheckedKeys(myConfigs, checkedData)
  checkedItems.map((item) => {
    coms.push({ key: item.key, title: item.name, type: 'text' })
  })
  var data = []
  itemList.map((item) => {
    var lineData = {}

    for (var key in checkKeyMap) {
      if (!item[key]) {
        lineData[key] = isShowZero ? 0 : ""
        continue
      }
      lineData[key] = item[key] && item[key] != "undefined" ? item[key] : ""
    }
    // checkKeys.forEach((key) => {
    //   if (!item[key]) return (lineData[key] = '')
    //   if (!checkKeyMap[key + '']) return
    //   console.log(item[key])
    //   lineData[key] = item[key]
    // })
    data.push(lineData)
  })
  var fileName = '导出excel.xlsx'
  ExportExcel(coms, data, fileName)

  //   console.log(itemList, checkedData)
  //   var coms = []
  //   var checkKeyMap = {}
  //   var checkKeys = []

  //   checkedData.map((d) => {
  //     var checkedItem = nameToItemMap[d]
  //     checkKeyMap[checkedItem.key + ''] = true
  //     coms.push({ key: checkedItem.key, title: checkedItem.name, type: 'text' })
  //     checkKeys.push(checkedItem.key + '')
  //   })
  //   var data = []
  //   itemList.map((item) => {
  //     var lineData = {}
  //     checkKeys.forEach((key) => {
  //       if (!item[key]) return (lineData[key] = '')
  //       if (!checkKeyMap[key + '']) return
  //       console.log(item[key])
  //       lineData[key] = item[key]
  //     })
  //     data.push(lineData)
  //   })
  //   var fileName = '至尊宝_导出excel.xlsx'
  //   ExportExcel(coms, data, fileName)
}
// export function GetCopyContent(itemList, checkedData) {
//   //获取ken
//   var checkKeyMap = {}
//   var checkKeys = []

//   checkedData.map((d) => {
//     checkKeyMap[nameToItemMap[d].key + ''] = true
//     checkKeys.push(nameToItemMap[d].key + '')
//   })
//   var content = ''
//   itemList.map((item) => {
//     var line = ''
//     checkKeys.forEach((key) => {
//       if (!item[key]) return
//       if (!checkKeyMap[key + '']) return
//       if (line != '') line += '\t'
//       line += item[key]
//     })
//     if (!line) return
//     if (content != '') content += '\n'
//     content += line
//   })
//   console.log('复制完毕了')
//   return content
// }
//将二维数组转换为csv


/*
 *导出csv 通用
 * 参数：
 *    headers：表头
 *             格式如：
 *             [
 *               {
 *                  column:"userid", //列字段
 *                  title: "姓名", //表头标题
 *                  formatter:(value) =>{return ... }   //格式化函数  
 *                },
 *                ...
 *              ]
 *    
 *    rows：行
 *          格式如：[{userid:101,gender:0 },{userid:102,gender:1}]
 *    filename：导出保存的文件名
 */
//参数处理函数
export function ExportCsv(itemList, myConfigs, checkedData, isShowZero) {
  var coms = []
  var { checkKeyMap, checkedItems } = getCheckedKeys(myConfigs, checkedData)
  checkedItems.map((item) => {
    coms.push({ key: item.key, title: item.name, type: 'text' })
  })
  var data = []
  itemList.map((item) => {
    var lineData = {}

    for (var key in checkKeyMap) {
      if (!item[key]) {
        lineData[key] = isShowZero ? 0 : ""
        continue
      }
      lineData[key] = item[key] && item[key] != "undefined" ? item[key] : ""
    }
    data.push(lineData)
  })


  var csv = csvHandler(checkedData, data,coms)
  csvDownload(csv, `csv下载.csv`)
  console.log(csv);
  debugger
}

//csv格式转换
function csvHandler(exportTitle, exportData,coms) {
  var keyArr = []
  let row = "",
    csvData = "";
  for (const title of exportTitle) {
    row += '"' + title + '",';
    coms.forEach(comItem => {
      if(title == comItem.title) {
        keyArr.push(comItem.key)
      }
    })
  }
  // 添加换行符号
  csvData += row + "\r\n"; 
  for (const item of exportData) {
    row = "";
    keyArr.forEach(key => {
      row += '"' + item[key] + '",';
    })
    // 添加换行符号
    csvData += row + "\r\n"; 
  }
  return csvData
}

const BOM = '\uFEFF'; 
function csvDownload(csv, filename = 'export.csv') {
  if (navigator.msSaveOrOpenBlob) {
    let blob = new Blob([BOM + csv], { type: 'text/csv;charset=utf-8;' });
    navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    let uri = encodeURI(`data:text/csv;charset=utf-8,${BOM}${csv}`);
    let downloadLink = document.createElement('a');
    downloadLink.href = uri;
    downloadLink.download = filename;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }
}
